import { callApi, pageToOffsetParams } from 'utils/api';

export function feedFetch(page) {
  return callApi('/mykooth/feed', {
    query: {
      ...pageToOffsetParams(page, process.env.KOOTH_PAGE_SIZE)
    }
  })
  .then(json => {
    const { feed, meta }  = json;

    const finalFeed = feed.map(feedItem => {
      const { chat, interests, journal, goals, questionnaire } = feedItem;
      if (chat) return ({...feedItem, chat: {...feedItem.chat, id: 0} });
      if (interests) return ({...feedItem, interests: {...feedItem.interests, id: 0}});
      if (journal) return ({...feedItem, journal: {...feedItem.journal, id: 0} });
      if (goals) return ({...feedItem, goals: {...feedItem.goals, id: 0} });
      if (questionnaire) return ({...feedItem, questionnaire: {...feedItem.questionnaire} });
      return feedItem;
    });

    return { feedItems: finalFeed, meta };
  });
}

export function feedQuestionnaireSubmit(feedQuestionnaire) {
  return callApi('/questionnaires', {
    method: 'POST',
    body: feedQuestionnaire
  });
}




/** WEBPACK FOOTER **
 ** ./src/members/state/feed/api.js
 **/